import React from "react";
import { DisabledPrompt, useBCMSContext, BCMSRecord } from "bcms-react";
import { MobileDevice } from "model";

import { TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { TableBody } from "components/shared/views/TableView";
import { SVGAsset } from "res";

import "./styles.css";
import "./mobile.css";

/**
 * @function AuthorizedDevicesTable
 * @return {React.Component}
 * @exported true
 * @description The main component for AuthorizedDevicesTable
 */
export default function AuthorizedDevicesTable(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor([ MobileDevice ], globalController);

    const devices = MobileDevice.initAll()
        .filter(item => item.isEnrolled, [])
        .map((item, index) => {
            // Time is hardcoded for now
            const minutes = index === 0 ? 0 : 30;
            item.enrolledDate.time = [8, minutes, 0];

            return item;
        }, [])
        .sort((a, b) => a.enrolledDate.date - b.enrolledDate.date);


    const rows = devices.map(item => <AuthorizedDevicesRow key={ item.id } mobileDevice={ item } />, []);

    return (
        <TableView className="authorized-devices-table">
            <TableColumnContainer>
                <TableColumnView className="text-left" text="Device Name" />
                <TableColumnView className="text-left" text="Date Enrolled" />
                <TableColumnView className="text-left" text="Delete" />
            </TableColumnContainer>
            <TableBody>
                { rows }
            </TableBody>
        </TableView>
    )
}

/**
 * @function AuthorizedDevicesRow
 * @return {React.Component}
 * @param {STRING} deviceName - The name of the user tied to all the devices.
 * @param {STRING} date - The date the device was added.
 * @param {STRING} time - The time the device was added.
 * @exported true
 * @description The main component for AuthorizedDevicesRow
 */
export function AuthorizedDevicesRow(props) {
    const mobileDevice = props.mobileDevice ?? {};

    return (
        <TableItemContainer>
            <TableItemTextView text={ mobileDevice.name } dataPoint={ `Device_Name_${ mobileDevice.id }`} />
            <TableItemTextView text={<><p>{mobileDevice.enrolledDate.format('m/d/Y h:i:s')}</p> <p>AM</p> </> } />
            <TableItemView>
                <DisabledPrompt>
                    <SVGAsset id="TrashcanXIcon" data-point={ `Device_Delete_${ mobileDevice.id }`} />
                </DisabledPrompt>
            </TableItemView>
        </TableItemContainer>
    )
}